import React from "react";
import { Card } from "antd";
import WorldFlag from "react-world-flags";

import { countriesAttributes } from "../constants/countriesAttributes";
import { MercadoPagoAuthButtom } from "./MercadoPagoAuthButtom";

export const Countries = () => {
  return (
    <div className="Countries">
      {countriesAttributes.map((country) => (
        <Card key={country.code} className="country-card" hoverable>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <WorldFlag code={country.code} height={20} />
            <h2 style={{ marginLeft: "10px" }}>{country.name}</h2>
          </div>
          <MercadoPagoAuthButtom countryCode={country.code} />
        </Card>
      ))}
    </div>
  );
};
